<template>
  <div class="test-block" style="max-height: 400px" :class="{openedAnswer: answerIsOpened}"
       :id="openedAnswer && openedAnswer.callback && openedAnswer.callback === 3 ? 'team-select' : ''" ref="mainScroll">
    <div style="display: flex; position: absolute; z-index: 1223123; top: -150px">
    </div>
    <div class="search-input" v-show="level === 1">
      <div class="search-zone">
        <input @keyup.enter="getSegmentItems(searchName)" class="search-field" :class="statusSearch ? 'search-err' : ''"
               type="text" v-model="searchName" :placeholder="settings.search_placeholder"/>
        <button class="clear-icon" v-show="searchName.length > 0" @click="clearField">&times;</button>
        <img class="search-icon"
             :src="iconSearch"
             @click="getSegmentItems(searchName)">
      </div>
      <div class="show-result widget-scroll" v-show="showResults">
        <div v-if="searchCategories || searchQuestions">
          <ul class="ask-widget__category-list" style="list-style-type: none; padding: 0 10px">
            <li :key="item.id" v-for="item in searchCategories" :style="{ color: settings.block_font }"
                @click="loadCategories('category', item)" v-html="item.name"></li>
          </ul>
          <ul class="ask-widget__category-list" style="list-style-type: none; padding: 0 10px">
            <li :key="item.id" v-for="item in searchQuestions" :style="{ color: settings.block_font }"
                @click="loadAnswer(item.question_id)" v-html="item.name">
            </li>
          </ul>
        </div>
        <div v-else-if="statusError">
          <p style="text-align: center">{{ statusError }}</p>
        </div>
        <div v-else>
          <p style="text-align: center">No data</p>
        </div>
      </div>
    </div>
    <div class="ask-widget__body widget-scroll" style="padding: 10px 20px 40px;" @scroll="handleScroll"
         ref="blockScroll"
         :class="{bodyFirstPage: level === 1}">
      <div class="ask-widget__container">
        <p class="ask-widget__body-description" v-html="ask.description" v-if="ask.description && !answerIsOpened"
           :style="{ color: settings.block_font }"></p>
        <div class="ask-widget__body-categories" v-if="!answerIsOpened">
          <ul class="ask-widget__important-list">
            <li :key="item.id" v-for="item in importantList" :style="{ color: settings.block_font }"
                @click="loadAnswer(item.question_id)">
              <img class="item-hot-img" :src="settings.important_image"><span v-html="item.name"></span>
            </li>
          </ul>
          <ul class="ask-widget__category-list">
            <li :key="item.id" v-for="item in orderedCategoriesList" :style="{ color: settings.block_font }">
              <span v-if="item.question_id" @click="loadAnswer(item.question_id)" v-html="item.name"></span>
              <span v-else @click="loadCategories('category', item)" v-html="item.name"></span>
            </li>
          </ul>
        </div>
        <div class="ask-widget__body-answer" id="ask-widget-answer" v-if="answerIsOpened">
          <div v-if="callNotClicked">
            <p v-html="setLinkWatcher(openedAnswer.answer)"></p>
            <ul class="answer__bindedQuestions">
              <li class="answer__bindedQuestions-item" :key="item.id" v-for="item in bindQuestions"
                  @click="loadAnswer(item.question_id)" v-html="item.name"></li>
            </ul>
            <div class="form-birthday" v-show="openedAnswer.self_exclusion_unlock === 1 && textDateAnswer.length === 0">
              <div class="field-block">
                <label>{{ settings.form_email }}</label>
                <input type="email" v-model="selectObjBirth.email" class="userForm-input"
                       :placeholder="settings.form_placeholder_email" required>
              </div>
              <div class="field-block">
                <label>{{ settings.date_of_birth }}</label>
                <input type="date" class="userForm-input" style="-webkit-appearance: none; -moz-appearance: none;"
                       v-model="selectObjBirth.date_of_birth">
                <p class="text-err-date" v-show="textDateErr.length > 0">{{ textDateErr }}</p>
              </div>
              <button class="save-btn" @click="sendAccessDate">{{ settings.form_save }}</button>
            </div>
            <p v-show="openedAnswer.self_exclusion_unlock === 1 && textDateAnswer.length > 0"
               class="text-answer-birthday">
              {{ textDateAnswer }}
            </p>
          </div>
          <div v-else class="answer-callResponse">
            <p class="answer-callResponse-text">{{ callResponse }}</p>
          </div>
        </div>
      </div>

      <div v-if="answerIsOpened && openedAnswer.callback === 3" class="team-select">
        <div v-if="!showSuccessTextTeam">
          <v-select :closeOnSelect="false" multiple :loading="optionsTeams.length <= 0" v-model="selectedTeams"
                    :options="optionsTeams"
                    :reduce="optionsTeams => optionsTeams.id"
                    key="id" label="name" :placeholder="settings.placeholder_football_club_save">
            <template #spinner="{ loading }">
              <div v-if="loading" class="vs__spinner"/>
            </template>
          </v-select>
          <button class="userForm-button" @click="setTeams">{{ settings.form_save }}</button>
        </div>
        <div v-else>
          {{ settings.football_club_save }}
        </div>
      </div>

    </div>
    <div class="body-blur" v-show="showBlurZone">
      <div class="zone-blur" :style="[
        {boxShadow: preloader || checkBlurBody ? 'none' : `inset 0px 0px 100px 20px ${settings.block_background}`},
        {filter: preloader || checkBlurBody ? 'none' : `blur(3px)`}
        ]"></div>
      <button class="body-arrow" :class="!statusArrowBtn ? 'arrow-down' : 'arrow-top'"
              :style="{ background: settings.theme_color}"
              @click="!statusArrowBtn ? scrollToBottom('mainScroll', 'blockScroll') : scrollToTop('mainScroll', 'blockScroll')"
      >
        <img class="arrow" :src="iconArrow" :class="!statusArrowBtn ? 'down' : 'up'" alt="">
      </button>
    </div>

    <div class="ask-widget__footer" v-if="level !== 1">
      <div class="footer__poll" v-if="answerIsOpened && (openedAnswer.callback == 2)">
        <div class="footer__webim" @click="callNew(openedAnswer.id)"
             v-if="showCallNew && (openedAnswer && openedAnswer.show_call_order_external === 1) && this.$userInfo.currency === 'BRL'"
             :style="{ background: settings.button_background, color: settings.button_font, marginRight: '10px' }">
          {{ settings.btn_call_auto_assign }}
        </div>
        <p class="footer__poll-title" style="margin-bottom: -1px; margin-top: 4px">{{ settings.poll_title }}</p>
        <div class="footer__poll-answer answer-yes" @click="closeWidget('btn_resolved', openedAnswer.id)">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL2SURBVHgBtVbBUhpBEJ2erJjkhLcUeFgvqWg8yBeoXyB/oPkCyU1Jqlguyi3wBeIXJH6B8AVolUJVLuwF5Ja9mOASptM9wyrssgSSsqummN2Zed39tvsNIGaY7bSTvt8/BMQdpEdhBpsLPEB8sxRcuKV1Nw4DpgIftewB4BmB7jy9RY+2e8GWCRDA6pKSxWmOIg5W881DhejQUlKDoqgkhKyGD6fzN1sgrG2FKjdy6FFAxbvTjXKsg1S+VRAanAPGYrf03hFzWOro1qE0CqN0nO7JejHiwEQuyhw1pbzbOdm8EgsYZ4QIl5w5ZfIxyEQ7YM59UA1eBFCZRcEnnUjCEV4CIcO0Sl4YSFXQnBMt/wrOps8CMj1JLhKdgYke2zR3u6cba+MHuEwHD78KCqR7d/KuMr7GlCIKewmhEi6A1PHtDw44sfxqRQ5gmOWXxFslHNHAv8/S+xygKqfz37eeHDeS/L14zZeiEEkFDJbv/8wRRXKPHyRYtcg+9cI1M/SGahj0gHCdDM/1GiJeh88pJav6PMI2pdNs00ARY0wTj6lrRG/cOaaJsS1hmsSN2+g6a17s2gyJGHW9LcUzGztwaUQoYFooxezfALiaYii0GVvCyMGbMJ/+PT9/neWEGuuAq6nf7084sKnh+JexJQLWdSpSHYxvcnXDqXOanqU/tfbD4KufWzskDV+ohCu90LcYoFFhJcQFcE37D8vUGMKjRluJRHl0U0aQhzS9Io0yXY5gaylHcd4tbRyEz3D1cCIKYU1yTVMqNXqRTOVJFUPWKW3mKM1dml4zsB6AnPruVHBWZOYfoMqZabFj/uWj2Fkkdm//U+zQUygzvUDsjCfQGo74+3JcFhYDZ7lm2YFi8F0e+6DD+o1GCclJY5TqXMZ7TeRGkcdvtciVmT5u5lCgkW9TxyRqVj1Mm+2QCvtiX+gr01yvHPnMKzMw80301RkuT9f8YHIUQABSGyJ86M1z6YcdWRL2EFV22t8WUtJ64uXr8iy9+gNiOJEbmCzORgAAAABJRU5ErkJggg=="
            class="emoji">
          <span class="answer"> {{ settings.poll_yes }}</span>
        </div>
        <div class="footer__poll-answer answer-no" @click="openChat()">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJ9SURBVHgBtVXbcdpAFN0VguEvSgekgkAFVj4ZYDAVmFSAXQGiAnAFJhXwHj6DKzAdRB1E/7xyzvpuZi0LBmP7zmi0j3vPfd/V6gSNRqOgUCh0DodDiG1JPlKCb621HnueN6lWq/ExDJ11uFwuS7vd7gHLUJ1Hw1wu18tS5KUPFotFB+BPAp7A+vv9ft8CwLd6va75cc0zfL9ErE2Z+Xx+q055APAuACNr1WazuWu1Wok6QfQWfBFCdWMAtY5qtVrvlQJaDvCBbO9g6UC9gcT6flpeWyskLMEl4BlKEoSxwpyYHAC8K+DDS8FJlJW8BFIkSov1f7hh8txKkLvfcvfD3k2n02vEnAAxQCuuEpZ2Pp8nXoDcfPUAcC13w3SZgSFUUv9Yl+05EhmKx2Ua4cqwKJBLU12+79/6+De5gWsTlSIoH+MXwvovWK/sOQQH2H/HMrPJoGAFIzr4rjQS85fWpMPzHnLCbpJMV9VHgaewSp76ZGIOYmqiW1leyMBjl4aIrfEWsWV3r44NOgkRl4knCpRbJRaYo4Mlx/Eh4OSNuWbXM87I4QN5XVkHa+2D8ZFlJ6U3tuAAfhKg++12O0jPJOFpY9khL/YVywPPmsI28Sgsbt+4lmC/Zrs3Go0oa+DxjJ3LBiRvsVgMbHjwo2I259jMIrjJbg3V86j4qd5BDJkoMFieaCIorWxnzfRziRNZwDnszMg2CqQS7AzvX6IkNe7/v24vHpzZbBYhnl3ZHn0GXZJk98Vyjoke82bvX73JYr0d30YR5xRA1laZvGJlVMuVAJOXIe6lx/3RR999Bs+gFfOY5a0+JUVFsL4JtznSy45XsXpuuMesHnHpH0/5jZyLvx7GAAAAAElFTkSuQmCC"
            class="emoji">
          <span class="answer"> {{ settings.poll_no }}</span>
        </div>
      </div>
      <div class="footer__contacts" v-if="answerIsOpened && openedAnswer.callback == 1">
        <div class="footer__webim" @click="callNew(openedAnswer.id)"
             v-if="showCallNew && (openedAnswer && openedAnswer.show_call_order_external === 1) && this.$userInfo.currency === 'BRL'"
             :style="{ background: settings.button_background, color: settings.button_font, marginRight: '10px' }">
          {{ settings.btn_call_auto_assign }}
        </div>
        <div class="footer__webim" @click="openChat('btn_operator')"
             v-if="openedAnswer.callback === 1"
             :style="{ background: settings.button_background, color: settings.button_font }">
          {{ settings.btn_operator }}
        </div>
        <a class="footer__links-url" target="_blank"
           v-if="settings.telegram_bot && (answerIsOpened && openedAnswer.callback == 1)"
           :href="settings.telegram_bot">
          <img class="footer__links-icon" :src="iconTelegram" alt="telegram">
        </a>
        <a class="footer__links-url" target="_blank"
           v-if="settings.viber_bot && (answerIsOpened && (openedAnswer.callback == 1))" :href="settings.viber_bot">
          <img class="footer__links-icon" :src="iconViber" alt="viber">
        </a>
      </div>

      <div class="footer__contacts" v-if="answerIsOpened && openedAnswer.callback == 4">
        <div class="footer__webim" @click="callNew(openedAnswer.id)"
             v-if="showCallNew && (openedAnswer && openedAnswer.show_call_order_external === 1) && this.$userInfo.currency === 'BRL'"
             :style="{ background: settings.button_background, color: settings.button_font, marginRight: '10px' }">
          {{ settings.btn_call_auto_assign }}
        </div>
      </div>
      <div class="footer__buttons">
        <button @click="backLevel()" class="footer__buttons-item" v-if="level != 1"> {{ settings.btn_back }}</button>
        <button @click="loadFirstLevel(true)" class="footer__buttons-item" v-if="level != 1"> {{
            settings.btn_main_menu
          }}
        </button>
        <button @click="callMeBack(openedAnswer.id)" class="footer__buttons-item" :disabled="disableCallMe"
                v-if="answerIsOpened && (openedAnswer.show_call_order == 1) && callNotClicked">
          {{ settings.btn_call_order }}
        </button>
      </div>
    </div>
    <div :class="{ 'ask-widget-overlay' : preloader, 'hidden-overlay' : !preloader }">
      <div class="ask-widget-preloader"></div>
    </div>
  </div>
</template>

<script>
import {sendAction} from '../services/sendAction'
import {closeWidget} from '../services/closeWidget'
import {globalState} from '../main'
import SearchIcon from '../assets/searchIcon.png'
import TelegramIcon from '../assets/telegram.svg'
import arrowIcon from '../assets/arrow.svg'
import ViberIcon from '../assets/viber.svg'
import orderBy from 'lodash/orderBy'
import Vue from 'vue'
const axios = require('axios')

export default {
  name: 'WidgetBody',
  mixins: [sendAction, closeWidget],
  data () {
    return {
      liveChatScript: '',
      statusFirstPage: false,
      beforeRenderMinusElem: 2,
      dataHistoryMethod: {},
      statusHistoryShow: JSON.parse(localStorage.getItem('dataHistory')) || false,
      categoriesObjs: [],
      dataTotalCategory: JSON.parse(localStorage.getItem('dataTotalCategory')) || [],
      answersIds: [],
      dataTotalAnswers: JSON.parse(localStorage.getItem('dataTotalAnswers')) || [],
      categoryOpenIds: [],
      answerOpenIds: [],
      openedAnswer: null,
      showCallNew: true,
      showSuccessTextTeam: false,
      selectedTeams: null,
      optionsTeams: [],
      checkBlurBody: false,
      showBlurZone: false,
      statusArrowBtn: false,
      linksLead: [],
      statusSearch: false,
      textDateErr: '',
      textDateAnswer: '',
      selectObjBirth: {},
      linksArrToSend: [],
      iconSearch: SearchIcon,
      iconTelegram: TelegramIcon,
      iconArrow: arrowIcon,
      iconViber: ViberIcon,
      importantList: null,
      bindQuestions: null,
      categoriesList: null,
      questionsList: null,
      searchCategories: null,
      searchQuestions: null,
      currentQuestionName: null,
      preloader: false,
      answerIsOpened: false,
      ask: {},
      settings: {},
      level: 0,
      callNotClicked: true,
      callResponse: null,
      disableCallMe: false,
      searchName: '',
      statusError: '',
      statusTeamError: '',
      showResults: false
    }
  },
  watch: {
    preloader () {
      if (!this.preloader) this.updateScrollLogic()
    },
    answerIsOpened (value) {
      this.$emit('setAnswerStatus', this.answerIsOpened)
    },
    level () {
      localStorage.setItem('getExpireData', new Date())
      if (!this.answerIsOpened) this.updateScrollLogic()
      this.statusArrowBtn = false
      this.checkBlurBody = false
    }
  },
  mounted () {
    this.level = 0
    this.settings = this.$settings
    this.ask = this.$ask
    if (this.statusHistoryShow) {
      if (this.statusHistoryShow.body.lang === this.ask.lang) {
        this.loadedDataFromLocalStorage()
      }
    } else {
      this.loadFirstLevel()
    }
    let urlData = `${this.ask.url}/api/ask/${this.settings.api_salt}/set-statistic-action`
    localStorage.setItem('getUrlData', urlData)
  },
  methods: {
    loadedDataFromLocalStorage () {
      let {body, url, level, status} = this.statusHistoryShow
      this.preloader = true
      this.level = level
      // for not send action_id=[] - array, because drop app
      if (status === 'category' && typeof body.action_id === 'number') {
        axios
          .post(url, {
            ask: body
          })
          .then(response => {
            this.preloader = false
            if (response.data.data === null) {
            } else {
              this.categoriesList = response.data.data.categories
              this.getQuestionsArrays(response.data.data.questions)
              this.ask.description = body.description
            }
          })
      } else if (status === 'answer') {
        // for answer (action by question)
        Vue.prototype.$lastClick = new Date()
        axios
          .post(url, {
            ask: body
          })
          .then(response => {
            this.level = level
            this.preloader = false
            this.openedAnswer = response.data.data.questions
            this.bindQuestions = response.data.data.bind_questions
            if (this.answerIsOpened) document.getElementById('ask-widget-answer').scrollIntoView()
            this.answerIsOpened = true
            this.callNotClicked = true
          })
      } else {
        // for first_view (action by show_list | btn_main)
        axios
          .post(url, {
            ask: body
          })
          .then(response => {
            this.preloader = false
            if (response.data.data === null) {
            } else {
              this.categoriesList = response.data.data.categories
              this.getQuestionsArrays(response.data.data.questions)
              if (response.data.data && response.data.data.links) {
                this.linksArrToSend = response.data.data.links
                this.linksLead = this.linksArrToSend.map((item, idx) => [`auth_profile_url-${idx}`, item])
              }
              this.ask.description = null
              this.preloader = false
            }
          })
      }
    },
    configPayloadAnswer (answerId) {
      return {
        brand: this.ask.brand,
        user_id: this.ask.user_id,
        lang: this.ask.lang,
        url: this.ask.url,
        uid: this.$userUid ? this.$userUid : localStorage.getItem('getUuid'),
        action_id: answerId,
        action: 'question'
      }
    },
    configPayloadCategory (categoryId) {
      return {
        action: 'category',
        action_id: categoryId,
        action_type: 'category',
        brand: this.ask.brand,
        description: this.ask.description,
        ip: this.ask.ip,
        lang: this.ask.lang,
        uid: this.$userUid ? this.$userUid : localStorage.getItem('getUuid'),
        url: this.ask.url,
        user_id: this.ask.user_id
      }
    },
    backLevel () {
      if (this.level === 2) {
        // A) в любому випадку грузить на першу сторінку якщо level: 2 і чистимо всі answers, categories з масивів(1рендер) і локалсторедж(2рендер)
        this.loadFirstLevel(true)
        this.answerIsOpened = false
        //
      } else if (this.dataTotalAnswers.length > 1 && this.statusHistoryShow) {
        this.statusFirstPage = false
        // B) після рендеру - включно answers(7205,7202) переходячи на categories(1370,1371)
        // після рендеру перебирає спершу всі answers з локалсторедж this.dataTotalAnswers
        this.loadBackAnswerLvl(this.dataTotalAnswers[this.dataTotalAnswers.length - 2], true)
        this.answerIsOpened = true
        this.sendAction('btn_back')
        //
      } else if (this.dataTotalAnswers.length <= 1 && this.dataTotalCategory.length !== 0) {
        this.statusFirstPage = false
        // C) після рендеру - включно лише categories(1370,1371)
        // після рендеру закінчивши перебирати answers перебираємо category з локалсторедж this.dataTotalCategory
        const minusElem = this.dataTotalAnswers.length !== 0 ? 1 : 2
        this.loadBackCategoryLvl(this.dataTotalCategory[this.dataTotalCategory.length - minusElem], true)
        this.sendAction('btn_back')
        this.answerIsOpened = false
        //
      } else if (this.answerOpenIds.length > 1) {
        this.statusFirstPage = false
        // D) працює при 1 рендеру - включно answers(7205,7202) переходячи на categories(1370,1371)
        // 1 рендер перебираємо з кінця answers
        this.answerIsOpened = true
        this.loadBackAnswerLvl(this.answerOpenIds[this.answerOpenIds.length - 2], false)
        localStorage.setItem('dataTotalAnswers', JSON.stringify(this.answersIds))
        this.sendAction('btn_back')
        //
      } else if (this.answerOpenIds.length <= 1 && this.categoryOpenIds.length !== 0) {
        this.statusFirstPage = false
        // E) працює при 1 рендеру - включно лише categories(1370,1371)
        // 1 рендер закінчивши перебирати answers перебираємо з кінця category
        this.answerIsOpened = false
        // localStorage.setItem('dataTotalCategory', JSON.stringify(this.categoriesObjs))

        // це для відслідковування переходу з answers на categories.
        const minusElem = this.answerOpenIds.length !== 0 ? 1 : 2
        // Якщо 1 - це перехід з answers на categories
        // Якщо 2 - це перехід по categories
        this.loadBackCategoryLvl(this.categoryOpenIds[this.categoryOpenIds.length - minusElem], false)
        this.sendAction('btn_back')
        //
      }
    },

    loadBackAnswerLvl (id, isReload) {
      this.preloader = true
      // this.categoryOpenIds.pop()
      // this.answerOpenIds.pop()
      let ask = this.configPayloadAnswer(id)

      Vue.prototype.$lastClick = new Date()
      if (isReload) {
        // work after reload
        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-answer', {
            ask
          })
          .then(response => {
            this.preloader = false
            this.openedAnswer = response.data.data.questions
            // this.answersIds.pop()
            // this.answerOpenIds.pop()
            // localStorage.setItem('dataTotalAnswers', JSON.stringify(this.answersIds))
            this.bindQuestions = response.data.data.bind_questions
            this.optionsTeams = this.openedAnswer.football_clubs && this.openedAnswer.football_clubs.filter(item => !item.value.includes('no_selected')).map(item => {
              let nameTeam = item.value.replace('t.property.favourite_football_team.', '').split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
              return {
                id: item.id,
                property_id: item.property_id,
                name: nameTeam
              }
            })
            this.dataTotalAnswers.pop()
            this.level -= 1
            // if (!this.answerIsOpened) this.level += 1
            if (this.answerIsOpened) document.getElementById('ask-widget-answer').scrollIntoView()
            this.answerIsOpened = true
            this.callNotClicked = true

            this.dataHistoryMethod.status = 'answer'
            this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-answer'
            this.dataHistoryMethod.body = ask
            this.dataHistoryMethod.level = this.level
            this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
            this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []
            // this.dataTotalCategory.uid = this.dataTotalCategory.hasOwnProperty('uid') ? this.dataTotalCategory.uid : localStorage.getItem('getUuid')
            localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))
            localStorage.setItem('dataTotalAnswers', JSON.stringify(this.dataTotalAnswers))
            // localStorage.setItem('dataTotalCategory', JSON.stringify(this.categoriesObjs))
          })
      } else {
        // work before reload
        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-answer', {
            ask
          })
          .then(response => {
            this.preloader = false
            this.openedAnswer = response.data.data.questions
            this.answersIds.pop()
            this.answerOpenIds.pop()
            localStorage.setItem('dataTotalAnswers', JSON.stringify(this.answersIds))
            this.bindQuestions = response.data.data.bind_questions
            this.optionsTeams = this.openedAnswer.football_clubs && this.openedAnswer.football_clubs.filter(item => !item.value.includes('no_selected')).map(item => {
              let nameTeam = item.value.replace('t.property.favourite_football_team.', '').split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
              return {
                id: item.id,
                property_id: item.property_id,
                name: nameTeam
              }
            })
            this.level -= 1
            // if (!this.answerIsOpened) this.level += 1
            if (this.answerIsOpened) document.getElementById('ask-widget-answer').scrollIntoView()
            this.answerIsOpened = true
            this.callNotClicked = true

            this.dataHistoryMethod.status = 'answer'
            this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-answer'
            this.dataHistoryMethod.body = ask
            this.dataHistoryMethod.level = this.level
            this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
            this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []
            // this.dataTotalCategory.uid = this.dataTotalCategory.hasOwnProperty('uid') ? this.dataTotalCategory.uid : localStorage.getItem('getUuid')
            localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))
          })
      }
    },
    loadBackCategoryLvl (payload, isReload) {
      this.preloader = true
      this.level -= 1
      Vue.prototype.$lastClick = new Date()
      if (isReload) {
        if (this.dataTotalAnswers.length === 0) {
          this.dataTotalCategory.pop()
          // this.categoriesObjs.pop()
        }
        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-category', {ask: payload})
          .then(response => {
            this.dataTotalAnswers = []
            this.preloader = false
            this.categoriesList = response.data.data.categories
            this.getQuestionsArrays(response.data.data.questions)
            this.ask.description = response.data.data.current.description

            this.dataHistoryMethod.status = 'category'
            this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-category'
            this.dataHistoryMethod.body = payload
            this.dataHistoryMethod.level = this.level
            this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
            this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []

            localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))
            localStorage.setItem('dataTotalCategory', JSON.stringify(this.dataTotalCategory))
            localStorage.setItem('dataTotalAnswers', JSON.stringify(this.dataTotalAnswers))
          })
      } else {
        if (this.answerOpenIds.length === 0) {
          this.categoryOpenIds.pop()
          this.categoriesObjs.pop()
        }
        let ask = this.configPayloadCategory(payload)
        // work before reload
        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-category', {ask})
          .then(response => {
            this.answerOpenIds = []
            this.preloader = false
            this.categoriesList = response.data.data.categories
            this.getQuestionsArrays(response.data.data.questions)
            this.ask.description = response.data.data.current.description

            this.dataHistoryMethod.status = 'category'
            this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-category'
            this.dataHistoryMethod.body = ask
            this.dataHistoryMethod.level = this.level
            this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
            this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []

            localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))
            localStorage.setItem('dataTotalCategory', JSON.stringify(this.categoriesObjs))
          })
      }
    },
    loadAnswer (index) {
      this.preloader = true
      let ask = this.configPayloadAnswer(index)
      Vue.prototype.$askData = ask
      Vue.prototype.$lastClick = new Date()
      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-answer', {
          ask
        })
        .then(response => {
          this.preloader = false
          this.openedAnswer = response.data.data.questions
          // need
          // this.checkExistIdsFromAnswersListLS(this.answersIds, this.openedAnswer.id)
          this.answersIds.push(this.openedAnswer.id)
          if (this.dataTotalAnswers.length === 0) {
            localStorage.setItem('dataTotalAnswers', JSON.stringify(this.answersIds))
          } else {
            this.dataTotalAnswers.push(this.openedAnswer.id)
            localStorage.setItem('dataTotalAnswers', JSON.stringify(this.dataTotalAnswers))
          }
          this.bindQuestions = response.data.data.bind_questions
          this.optionsTeams = this.openedAnswer.football_clubs && this.openedAnswer.football_clubs.filter(item => !item.value.includes('no_selected')).map(item => {
            let nameTeam = item.value.replace('t.property.favourite_football_team.', '').split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
            return {
              id: item.id,
              property_id: item.property_id,
              name: nameTeam
            }
          })
          this.level += 1
          // if (!this.answerIsOpened) this.level += 1
          if (this.answerIsOpened) document.getElementById('ask-widget-answer').scrollIntoView()
          this.answerIsOpened = true
          this.callNotClicked = true

          this.dataHistoryMethod.status = 'answer'
          this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-answer'
          this.dataHistoryMethod.body = ask
          this.answerOpenIds.push(index)
          this.dataHistoryMethod.level = this.level
          this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
          this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []
          // this.dataTotalCategory.uid = this.dataTotalCategory.hasOwnProperty('uid') ? this.dataTotalCategory.uid : localStorage.getItem('getUuid')
          localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))
        })
    },
    loadCategories (type, item) {
      this.preloader = true
      let ask = this.ask
      ask.action = type
      ask.action_id = item.id

      this.currentQuestionName = item.name ? item.name.replace(/<[^>]*>/g, '').trim() : ''
      ask.uid = this.$userUid ? this.$userUid : localStorage.getItem('getUuid')
      ask.action_type = type
      Vue.prototype.$lastClick = new Date()
      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-category', {
          ask
        })
        .then(response => {
          this.preloader = false
          if (response.data.data === null) {
          } else {
            this.categoriesList = response.data.data.categories
            this.getQuestionsArrays(response.data.data.questions)
            ask.description = this.setLinkWatcher(item.description)
            // this.categoryOpenIds.push(item.parent_id)
            this.categoryOpenIds.push(item.id)
            this.level += 1
            this.categoriesObjs.push({...ask})
            if (this.dataTotalCategory.length === 0) {
              localStorage.setItem('dataTotalCategory', JSON.stringify(this.categoriesObjs))
            } else {
              this.dataTotalCategory.push(ask)
              localStorage.setItem('dataTotalCategory', JSON.stringify(this.dataTotalCategory))
            }
            this.dataHistoryMethod.status = 'category'
            this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-category'
            this.dataHistoryMethod.body = ask
            this.dataHistoryMethod.level = this.level
            this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
            this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []
            this.dataHistoryMethod.uid = this.dataTotalCategory.hasOwnProperty('uid') ? this.dataTotalCategory.uid : localStorage.getItem('getUuid')
            // this.dataTotalCategory.uid = this.dataTotalCategory.hasOwnProperty('uid') ? this.dataTotalCategory.uid : localStorage.getItem('getUuid')
            localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))
          }
        })
    },
    initializeDataAnswersCategories () {
      this.categoryOpenIds = []
      this.answerOpenIds = []
      this.categoriesObjs = []
      this.dataTotalCategory = []
      this.answersIds = []
      // localStorage.setItem('dataReloadCategory', JSON.stringify([]))
      localStorage.setItem('dataTotalCategory', JSON.stringify(this.dataTotalCategory))
      localStorage.setItem('dataTotalAnswers', JSON.stringify([]))
    },
    loadFirstLevel (action) {
      this.showResults = false
      this.searchName = ''
      this.preloader = true
      let ask = this.ask
      if (action) {
        ask.action = 'btn_main'
        this.textDateAnswer = ''
        delete ask.action_id
      } else {
        ask.action = 'show_list'
      }
      ask.uid = this.$userUid ? this.$userUid : localStorage.getItem('getUuid')
      this.answerIsOpened = false
      this.openedAnswer = null
      this.level = 1
      Vue.prototype.$lastClick = new Date()

      this.dataHistoryMethod.status = 'first'
      this.dataHistoryMethod.url = this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-first'
      this.dataHistoryMethod.body = ask
      this.dataHistoryMethod.totalItem = {}
      this.dataHistoryMethod.level = this.level
      this.dataHistoryMethod.userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo
      this.dataHistoryMethod.links = !this.statusHistoryShow.links ? this.linksArrToSend : []

      localStorage.setItem('dataHistory', JSON.stringify(this.dataHistoryMethod))

      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-first', {ask})
        .then(response => {
          this.categoriesList = response.data.data.categories
          this.getQuestionsArrays(response.data.data.questions)
          if (response.data.data && response.data.data.links) {
            this.linksArrToSend = response.data.data.links
            this.linksLead = this.linksArrToSend.map((item, idx) => [`auth_profile_url-${idx}`, item])
          }
          this.ask.description = null
          this.preloader = false
          this.statusFirstPage = true
          this.initializeDataAnswersCategories()
        })
    },
    // __________________________________________________

    setLinkWatcher (link) {
      return link.replaceAll('<a ', `<a style="color: ${this.settings.link_color_static}!important;"
        onmouseover="this.style.color='${this.settings.link_color_hover}'"
        onmouseout="this.style.color='${this.settings.link_color_static}'"
        onclick="(function(){
          localStorage.setItem('getExpireData', new Date())
          fetch(localStorage.getItem('getUrlData'), {
            method: 'post', body: JSON.stringify({ask: { action: 'link_segue',uid: localStorage.getItem('getUuid')}})}).then((res)=>{
            }).catch(()=>{})})(event)"`)
    },
    getValueScroll (name) {
      var div = this.$refs[name]

      if (this.answerIsOpened && div) {
        return div.scrollHeight > div.clientHeight
      } else if (div) {
        return div.scrollHeight > div.clientHeight
      }
    },
    setTeams () {
      if (this.selectedTeams && this.selectedTeams.length > 0) {
        let ask = {
          brand: this.ask.brand,
          user_id: this.ask.user_id,
          lang: this.ask.lang,
          property: {
            id: this.optionsTeams[0].property_id,
            value: this.selectedTeams
          }
        }
        axios
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/set-property', {ask})
          .then(_ => {
            this.showSuccessTextTeam = true
            this.selectedTeams = null
          })
      }
    },
    updateScrollLogic () {
      setTimeout(() => {
        this.$refs.blockScroll.scrollTop = 0
        this.statusArrowBtn = false
        this.showBlurZone = this.getValueScroll('blockScroll')
      }, 0)
    },
    handleScroll ({target: {scrollTop, clientHeight, scrollHeight}}) {
      if (scrollTop + clientHeight >= scrollHeight * 0.96) {
        this.statusArrowBtn = true
      } else if (scrollTop <= 0) {
        this.statusArrowBtn = false
      }

      if (scrollTop + clientHeight >= scrollHeight) {
        this.checkBlurBody = true
      } else {
        this.checkBlurBody = false
      }
    },
    scrollToBottom (refMain, refClient) {
      var main = this.$refs[refMain]
      var client = this.$refs[refClient]
      client.scrollBy({
        top: main.clientHeight * 0.66,
        behavior: 'smooth'
      })
    },
    scrollToTop (refMain, refClient) {
      var main = this.$refs[refMain]
      var client = this.$refs[refClient]
      client.scrollBy({
        top: main.clientHeight * -0.66,
        behavior: 'smooth'
      })
    },
    clearField () {
      this.searchName = ''
      this.showResults = false
    },
    sendAccessDate () {
      let ask = {
        lang: this.ask.lang,
        brand: this.ask.brand,
        email: this.selectObjBirth.email,
        date_of_birth: this.selectObjBirth.date_of_birth
      }
      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/amnesty', {ask})
        .then(response => {
          this.textDateErr = ''
          this.textDateAnswer = response.data.data
        }).catch(e => {
          this.textDateErr = e.response.data.error_description
        })
    },
    getSegmentItems (value) {
      if (value.length === 0) {
        this.statusSearch = true
      } else {
        this.statusSearch = false
        this.preloader = true
        Vue.prototype.$lastClick = new Date()
        let ask = {
          brand: this.ask.brand,
          user_id: this.ask.user_id,
          lang: this.ask.lang
        }
        if (value.length >= 1) {
          ask['name'] = value
        } else {
          ask['name'] = ''
          this.searchCategories = []
          this.searchQuestions = []
          this.preloader = false
          this.showResults = false
        }
        axios
          // 'https://new-dev.go2ask.org'
          .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/get-search', {
            ask
          })
          .then(response => {
            this.searchCategories = response.data.data.categories
            this.searchQuestions = response.data.data.questions
            this.showResults = true
            this.preloader = false
            this.statusError = response.data.error
          })
      }
    },
    getQuestionsArrays (questions) {
      this.importantList = []
      this.questionsList = []
      if (questions) {
        questions.forEach(item => {
          if (item.is_important === '1') {
            this.importantList.push(item)
          } else {
            this.questionsList.push(item)
          }
        })
      }
    },
    /* eslint-disable */
    convertStripWithoutTags(value) {
      return value.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, '').replace(/[\n\r]/g, '')
    },
    openChat(type) {
      if (this.openedAnswer.is_not_open_webim == 1) {
        this.closeWidget('btn_not_resolved', this.openedAnswer.id)
      } else if (this.openedAnswer.is_not_open_webim == 0) {
        this.$userInfo = this.statusHistoryShow.userInfo ? this.statusHistoryShow.userInfo : this.$userInfo

        if (this.$settings.use_widget === 1) {
          if (this.settings.widget_type_code === 'live_chat') {
            var script = document.createElement('script')

            if (this.settings.chat_id == 158) {
              var userLangs = navigator.languages
              if (userLangs.includes('uk') || this.$userInfo.currency === 'UAH') {
                this.liveChatScript = `window.__lc = window.__lc || {};window.__lc.license = ${this.settings.livechat_code}; window.__lc.chat_between_groups = false; window.__lc.group = "159";;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can\'t use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))\n`
                script.innerHTML = this.liveChatScript
              } else {
                this.liveChatScript = `window.__lc = window.__lc || {};window.__lc.license = ${this.settings.livechat_code}; window.__lc.chat_between_groups = false; window.__lc.group = "${this.settings.chat_id}";;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can\'t use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))\n`
                script.innerHTML = this.liveChatScript
              }
            } else {
              this.liveChatScript = `window.__lc = window.__lc || {};window.__lc.license = ${this.settings.livechat_code}; window.__lc.chat_between_groups = false; window.__lc.group = "${this.settings.chat_id}";;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can\'t use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))\n`
              script.innerHTML = this.liveChatScript
            }
            let liveChatHistory = {
              initializeScript: this.liveChatScript,
              userInfo: {
                ...this.$userInfo,
                langDefault: this.ask.lang
              }
            }
            globalState.visibleOfLiveChat = true
            localStorage.setItem('liveChatHistory', JSON.stringify(liveChatHistory))
            localStorage.setItem('getExpireDateOfLiveChat', new Date())

            document.body.appendChild(script)
            LiveChatWidget.call('set_customer_name', `${this.$userInfo.first_name}`)
            // LiveChatWidget.call('set_customer_email', this.$userInfo.email)
            LiveChatWidget.call('update_session_variables', {
              // prechat_phone: this.$userInfo.phone,
              player_id: this.ask.user_id,
              brand_id: this.ask.brand
            })

            if (this.openedAnswer.name) {
              LiveChatWidget.call('update_session_variables', {
                prechat_question: this.convertStripWithoutTags(this.openedAnswer.name)
              })
            }

            if (this.$userInfo.currency) {
              LiveChatWidget.call('update_session_variables', {
                currency: this.$userInfo.currency
              })
            }
            if (this.$userInfo.email_verified) {
              LiveChatWidget.call('update_session_variables', {
                email_verified: this.$userInfo.email_verified
              })
            }
            if (this.$userInfo.appeals || this.$userInfo.appeals === 0) {
              LiveChatWidget.call('update_session_variables', {
                appeals: this.$userInfo.appeals
              })
            }
            if (this.$userInfo.is_vip) {
              LiveChatWidget.call('update_session_variables', {
                is_vip: this.$userInfo.is_vip
              })
            }
            if (this.$userInfo.tags) {
              LiveChatWidget.call('update_session_variables', {
                tags: this.$userInfo.tags
              })
            }
            if (this.$userInfo.phone_verified) {
              LiveChatWidget.call('update_session_variables', {
                phone_verified: this.$userInfo.phone_verified
              })
            }

            if (this.statusHistoryShow && (this.statusHistoryShow.links || this.statusHistoryShow.userInfo.lead_profile_url)) {

              const linksFromLS = this.statusHistoryShow.links.map((item, idx) => [`auth_profile_url-${idx}`, item])
              if (this.statusHistoryShow.links && this.statusHistoryShow.links.length) {
                LiveChatWidget.call('update_session_variables', Object.fromEntries(linksFromLS))
              } else if (this.statusHistoryShow.userInfo.lead_profile_url) {
                LiveChatWidget.call('update_session_variables', {
                  lead_profile_url: this.statusHistoryShow.userInfo.lead_profile_url
                })

              }
            } else {
              if (this.ask.lead_profile_url === undefined && this.linksArrToSend.length > 0) {
                LiveChatWidget.call('update_session_variables', Object.fromEntries(this.linksLead))
              } else if (this.ask.lead_profile_url !== undefined && this.linksArrToSend.length === 0) {
                LiveChatWidget.call('update_session_variables', {
                  lead_profile_url: this.ask.lead_profile_url
                })
              }
            }
            LiveChatWidget.call('maximize')

            // const closeIcon = document.querySelector('.esv0owm2')
            // console.log(closeIcon)

            LiveChatWidget.on('ready', function() {
              localStorage.setItem('statusLiveChat', 'maximized')

              LiveChatWidget.on('visibility_changed', function (data) {
                localStorage.setItem('statusLiveChat', data.visibility)
              })

              LiveChatWidget.on('customer_status_changed', function (data) {
                if (data.status === 'browsing'){
                  localStorage.removeItem('liveChatHistory')
                  localStorage.removeItem('statusLiveChat')
                  localStorage.removeItem('getExpireDateOfLiveChat')
                }
              })
            });
          } else if (this.settings.widget_type_code === 'live_agent') {
            const sendFieldsForChatSystem = {
              name: this.$userInfo.first_name,
              brand: this.ask.brand,
              currency: this.$userInfo.currency,
              email_verified: this.$userInfo.email_verified,
              phone_verified: this.$userInfo.phone_verified,
              uuid: this.$registered ? this.ask.user_id : 0,
              lead_profile_url: this.$registered ? this.ask.lead_profile_url : "",
              prechat_question: this.currentQuestionName ? this.currentQuestionName : "",
              is_vip: this.$userInfo.is_vip
            }

            let messageParams = "";

            for (var key in sendFieldsForChatSystem){
              messageParams += `${key}: ${sendFieldsForChatSystem[key]} \n`
            }

            var script = document.createElement('script');
            script.innerHTML = `(function(d, src, c) { var t=d.scripts[d.scripts.length - 1],s=d.createElement('script');s.id='la_x2s6df8d';s.defer=true;s.src=src;s.onload=s.onreadystatechange=function(){var rs=this.readyState;if(rs&&(rs!='complete')&&(rs!='loaded')){return;}c(this);};t.parentElement.insertBefore(s,t.nextSibling);})(document,'https://${this.settings.liveagent_company_name}.ladesk.com/scripts/track.js',function(e){ LiveAgent.createButton('${this.settings.chat_id}', e, ${JSON.stringify(messageParams)}); });`
            // script.innerHTML = `(function(d, src, c) { var t=d.scripts[d.scripts.length - 1],s=d.createElement('script');s.id='la_x2s6df8d';s.defer=true;s.src=src;s.onload=s.onreadystatechange=function(){var rs=this.readyState;if(rs&&(rs!='complete')&&(rs!='loaded')){return;}c(this);};t.parentElement.insertBefore(s,t.nextSibling);})(document,'https://${this.settings.liveagent_company_name}.ladesk.com/scripts/track.js',function(e){ LiveAgent.createButton('${this.settings.chat_id}', e); });`

            document.body.appendChild(script)
          }  else {
            alert('Can\'t open chat!')
            this.closeWidget('btn_not_resolved', this.openedAnswer.id)
          }
          if (type) {
            this.closeWidget(type, this.openedAnswer.id)
          } else {
            this.closeWidget('btn_not_resolved', this.openedAnswer.id)
          }
        }
      }
    },
    sortObject(obj) {
      return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key]
        return result
      }, {})
    },
    callNew(answer) {
      let ask = {
        action: 'external_prechat_recall',
        uid: this.$userUid ? this.$userUid : localStorage.getItem('getUuid'),
        user_id: this.ask.user_id,
        brand: this.ask.brand,
        action_id: answer,
        lang: this.ask.lang
      }

      this.disableCallMe = true
      setTimeout(() => {
        this.disableCallMe = false
      }, 5000)

      this.ask.description = null
      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/recall', {ask})
        .then(response => {
          if (response.data.messages) {
            this.callResponse = response.data.messages
          } else {
            this.callResponse = this.$settings.recall_chat
          }
          this.callNotClicked = false
          this.showCallNew = false
        })
    },
    callMeBack(answer) {
      let ask = {
        action: 'btn_call',
        uid: this.$userUid ? this.$userUid : localStorage.getItem('getUuid'),
        user_id: this.ask.user_id,
        brand: this.ask.brand,
        action_id: answer,
        lang: this.ask.lang
      }

      this.disableCallMe = true
      setTimeout(() => {
        this.disableCallMe = false
      }, 5000)

      this.ask.description = null
      axios
        .post(this.ask.url + '/api/ask/' + this.settings.api_salt + '/recall', {ask})
        .then(response => {
          if (response.data.messages) {
            this.callResponse = response.data.messages
          } else {
            this.callResponse = this.$settings.recall_chat
          }
          this.callNotClicked = false
        })
    },
    convertArrayToObject(array, key) {
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item,
        }
      }, {})
    },
  },
  computed: {
    orderedCategoriesList: function () {
      this.questionsList = this.convertArrayToObject(this.questionsList ? this.questionsList : [], 'id')
      let arrTotal = {...this.categoriesList, ...this.questionsList}
      return orderBy(arrTotal, 'sort')
    }
  }
}
</script>

<style scoped>
.text-answer-birthday {
  text-align: center !important;
  color: green !important;
  font-size: 16px !important;
}

.field-block input {
  width: 100%;
  display: block;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #c7c9ca;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #393f6b;
  font: 13px/1.2em Ubuntu, normal Arial, Helvetica, sans-serif;
  line-height: 36px;
  padding: 0 10px;
  height: 36px;
  border-radius: 9px;
}

.field-block input:focus {
  border-color: #40d6bd;
  outline: none;
}
</style>

<style>
.datetime-input {
  width: 100% !important;
}

.datetime-input .el-input__inner {
  width: 100%;
  border: 1px solid #c7c9ca;
  border-radius: 9px;
}

.form-birthday .field-block {
  margin-bottom: 15px;
}

.text-err-date {
  font-size: 13px !important;
  margin: 0;
  font-weight: 600;
  color: red !important;
}

.save-btn {
  background: #0d76d9;
  color: #fff;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
  font-weight: bold;
  line-height: 30px;
  overflow: hidden;
  outline: none;
  padding: 2px 10px;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 0.29px;
  border-radius: 20px;
  min-width: 80px;
}

</style>



// WEBPACK FOOTER //
// src/components/WidgetBody.vue